
/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('Product_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/products/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get:   { method: 'GET' },
                getQuantityHistory:   { method: 'GET', isArray: false , url:baseUrl+'rest/products/getQuantityHistory/:id' },
                getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/products/deleted'},
                emptyTrash: { method: 'POST', isArray: true , url:baseUrl+'rest/products/emptyTrash'},
                saveNoQuantity: {method: 'POST', url:baseUrl+'rest/products/saveNoQuantity'}
            }
        );
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Product',["Product_Resource","ImageData","ProductData","SupplierData","ProductCategoryData","CompanyImageData","VatData","HrRootCategory",
        function (Product_Resource,ImageData,ProductData,SupplierData,ProductCategoryData,CompanyImageData,VatData,HrRootCategory)
    {

        var Product = function (resource,parentCategory)
        {
            this.id = null;
            this.isDeleted;
            this.label = "";
            this.code = "";
            this.reference = "";
            this.description= "";
            this.buyingPrice= null;
            this.isOnHome= false;
            this.homeOrder= 0;
            this.price= null;
            this.hasInternetPrice= false;
            this.internetPrice= null;
            this.quantity= null;
            this.hasQuantity = true;
            this.supplier=null;
            this._supplierId=null;  //tmp for loading only
            this.vat=null;
            this._vatId=null;  //tmp for loading only
            this.image = null;
            this.companyImage = null;
            this.specificImage = null;
            this.isVisibleOnWebSite = true;//Default;
            this.isBuyableOnWebSite = true;//Default;
            this.version = null;

            if (resource !== undefined && resource != null)
            {
                this.loadObject(resource);
            }

            if (parentCategory !== undefined && parentCategory != null)
            {
                this.parentCategory = parentCategory;
            }

            ProductData.add(this);
        }
        Product.prototype.loadObject = function(object,parentCategory)
        {
            //Assume here than the object in parameter contains only id (must load them)

            if (!this.id)
                this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.parentCategoryId =  object.parentCategoryId;
            this.label = object.label;
            this.code = object.code;
            this.reference = object.reference;
            this.description= object.description;
            this.buyingPrice= object.buyingPrice;
            this.price= object.price;
            this.isOnHome= object.isOnHome;
            this.homeOrder= object.homeOrder;
            this.hasInternetPrice= object.hasInternetPrice;
            this.internetPrice= object.internetPrice;
            this.hasQuantity= object.hasQuantity;
            this.quantity= object.quantity;
            this._supplierId = object.supplierId;
            this._vatId = object.vatId;
            this.imageId =  object.imageId;
            this.companyImageId =  object.companyImageId;
            this.specificImage = object.specificImage;
            this.isVisibleOnWebSite = object.isVisibleOnWebSite;
            this.isBuyableOnWebSite = object.isBuyableOnWebSite;

            if (parentCategory!==undefined && parentCategory!=null)
            {
                this.parentCategory=  parentCategory;
            }
            if (object.version)
                this.version = object.version;
        }
        Product.prototype.getObjectResource = function()
        {
            var rsProduct = new Product_Resource();
            rsProduct.id = this.id;
            rsProduct.isDeleted = this.isDeleted;
            rsProduct.code =this.code;
            rsProduct.reference =this.reference;
            rsProduct.label =this.label;
            if (this.image)
                rsProduct.imageId = this.image.id;
            if (this.companyImage)
                rsProduct.companyImageId = this.companyImage.id;
            rsProduct.specificImage = this.specificImage;
            rsProduct.description = this.description ;
            rsProduct.price= this.price;
            rsProduct.isOnHome= this.isOnHome;
            rsProduct.homeOrder= this.homeOrder;
            rsProduct.hasInternetPrice= this.hasInternetPrice;
            rsProduct.internetPrice= this.internetPrice;
            rsProduct.buyingPrice= this.buyingPrice;
            rsProduct.hasQuantity = this.hasQuantity;
            rsProduct.quantity = this.quantity;
            if (this.supplier!=null)
                rsProduct.supplier = this.supplier.getObjectResource();//Always allow update
            else
                rsProduct.supplier=null;
            if (this.vat!=null)
                rsProduct.vatId = this.vat.id;
            else
                rsProduct.vatId=null;
            rsProduct.isVisibleOnWebSite = this.isVisibleOnWebSite;
            rsProduct.isBuyableOnWebSite = this.isBuyableOnWebSite;

            //needPhysicalResource &&  needHumanResource MANAGED BY SERVER
            if (this.parentCategory!=null)
                rsProduct.parentCategoryId = this.parentCategory.getId();
            return rsProduct;
        }

        Product.prototype.loadRef =  function()
        {
            if (this.imageId)
                this.image = ImageData.getById(this.imageId);
            if (this.companyImageId)
                this.companyImage = CompanyImageData.getById(this.companyImageId);
            if (this.parentCategory==null && this.parentCategoryId)
                this.parentCategory = ProductCategoryData.getById(this.parentCategoryId);
            if (this._supplierId)
            {
                this.supplier = SupplierData.getById(this._supplierId);
                if (this.supplier)
                    this.supplier.addProduct(this);
            }
            if (this._vatId)
                this.vat = VatData.getById(this._vatId);
        }
        Product.prototype.getId = function()
        {
            return this.id;
        }
        Product.prototype.setId = function(id)
        {
            this.id = id;
        }
        Product.prototype.getLabel = function()
        {
            return this.label;
        }
        Product.prototype.reload = function(endFunction)
        {
            var productSrv = this.getObjectResource();
            var product = this;
            if (this.getId()!=null)
                productSrv.$get({id:this.getId()}, //params
                    function (data) {   //success
                        product.loadObject(data);
                        if (endFunction !=undefined)
                            endFunction(product);
                    },
                    function (data) {   //failure
                        //error handling goes here
                        //TODO
                    });
        }

        Product.prototype.isDescendantOf = function(category) {
            var isDescendantOf = false;
            if(this.parentCategory === category) {
                isDescendantOf = true;
            }
            else {
                if(this.parentCategory) {
                    isDescendantOf = this.parentCategory.isDescendantOf(category);
                }
            }

            return isDescendantOf;
        }

        return Product;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ProductSrv',["$log","HumanResourceData","HumanResourceSrv","Product_Resource","Product","ProductCategoryData","UserActionData","ProductData","ServerSrv",
        function ($log,HumanResourceData,HumanResourceSrv,Product_Resource,Product,ProductCategoryData,UserActionData,ProductData,ServerSrv)
    {
        var  productSrv =
        {};
        productSrv.save =  function(product,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(productSrv.saveSync, product, successFunction, errorFunction);
        };
        productSrv.saveSync = function(product,successFunction,errorFunction)
        {
            //$timeout (function () {

            var ProductRes = product.getObjectResource();
            ProductRes.$save({}, //no params
                function (data) {
                    try{
                        if(product.id == null) {
                            product.setId(data.id);
                        }
                        if (!product.version || (data.version && data.version > product.version))
                            product.version = data.version;
                        /** @namespace data.supplierId */
                        if (data.supplierId && product.supplier)
                            product.supplier.id = data.supplierId;

                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        productSrv.saveNoQuantity =  function(product,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(productSrv.saveNoQuantitySync, product, successFunction, errorFunction);
        };
        productSrv.saveNoQuantitySync = function(product,successFunction,errorFunction)
        {
            //$timeout (function () {

            var ProductRes = product.getObjectResource();
            ProductRes.$saveNoQuantity({}, //no params
                function (data) {
                    try{
                        if(product.id == null) {
                            product.setId(data.id);
                        }
                        if (!product.version || (data.version && data.version > product.version))
                            product.version = data.version;
                        /** @namespace data.supplierId */
                        if (data.supplierId && product.supplier)
                            product.supplier.id = data.supplierId;

                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        productSrv.getQuantityHistory = function(product,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(productSrv.getQuantityHistorySync, product, successFunction, errorFunction);
        }
        productSrv.getQuantityHistorySync = function(product,successFunction,errorFunction)
        {
            Product_Resource.getQuantityHistory(
                {id:product.id}, //params
                function (productHistory) {   //success
                    try{
                    //Update quantity dynamically
                    if (productHistory && productHistory.productVersions && productHistory.productVersions.length!=0 &&
                        productHistory.productVersions[productHistory.productVersions.length-1].quantity!==undefined)
                        product.quantity = productHistory.productVersions[productHistory.productVersions.length-1].quantity;

                    if (successFunction!== undefined )
                        successFunction(productHistory);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try{
                        $log.error("Product_Resource.getQuantityHistory error");
                        $log.error(data);
                        if (errorFunction!== undefined)
                            errorFunction(data);

                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                });
        }
        productSrv.emptyTrash = function(successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(productSrv.emptyTrashSync, successFunction, errorFunction);
        }
        productSrv.emptyTrashSync = function(successFunction,errorFunction)
        {
            Product_Resource.emptyTrash({}, //params : id
                function (data) {
                    try{
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        }
        productSrv.remove =  function(product,successFunction,errorFunction)
        {
            ProductData.remove(product);
            ServerSrv.startSavingProcess(productSrv.removeSync, product, successFunction, errorFunction);
        };
        productSrv.removeSync =  function(product,successFunction,errorFunction)
        {
            //$timeout (function () {

            var productRes = new Product_Resource();
            productRes.$remove({id:product.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        productSrv.restore =  function(product,successFunction,errorFunction)
        {
            ProductData.restore(product);
            ServerSrv.startSavingProcess(productSrv.restoreSync, product, successFunction, errorFunction);
        };
        productSrv.restoreSync =  function(product,successFunction,errorFunction)
        {
            //$timeout (function () {

            var productRes = product.getObjectResource();
            productRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        productSrv.query = function(successFunction,errorFunction)
        {
            Product_Resource.getDeleted(
                {}, //params
                function (data) {   //success

                    ProductData.deletedProducts = [] ;
                    for (var i=0;i< data.length;i++)
                        new Product(data[i]);//Auto Add to ProductData

                    if (successFunction!== undefined )
                        successFunction(ProductData.categoryRoot);
                },
                function (data) {   //failure
                    $log.error("Product_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);

                });
        }
        productSrv.loadRef =  function()
        {
            var products = ProductData.indexProducts;
            for (var i=0;i<products.length;i++)
                products[i].loadRef();

        }
        productSrv.updateLocally =  function(id,object)
        {
            var product =  null;
            var category = ProductCategoryData.getById(object.parentCategoryId);
            if (category!=null)
                product = category.getProductById(id)
            if (product!=null)
            {
                product.loadObject(object,category);
            }
            return product
        }
        productSrv.addLocally =  function(id,object)
        {
            var product =  null;
            var category = ProductCategoryData.getById(object.parentCategoryId);
            if (category!=null)
            {
                product  = new Product(object,category);
                product.id = id;
                category.addProduct(product);

            }
            return null;

        }
        productSrv.removeLocally =  function(id,object)
        {
            var product =  null;
            var category = ProductCategoryData.getById(object.parentCategoryId);
            if (category!=null)
                product = category.getProductById(id)
            if (product!=null)
                category.removeProduct(product);
            return product;
        }

        return productSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ProductData',["$log", function ($log)
    {
        var  productData =
        {
            indexProducts : [], //Used as Index
            deletedProducts : []
        };
        productData.getById =  function(productId)
        {
            for (var i=0;i<this.indexProducts.length;i++)
                if (this.indexProducts[i].id==productId)
                    return this.indexProducts[i];
            return null;
        }
        productData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexProducts.length)
            {
                return this.indexProducts[servIndex];
            }
            else
                return null;
        }
        productData.getByRef =  function(reference)
        {
            for (var i=0;i<this.indexProducts.length;i++)
                if (this.indexProducts[i].reference==reference)
                    return this.indexProducts[i];
            return null;
        }
        productData.getIndexOf =  function(product)
        {
            if (product)
                return this.indexProducts.indexOf(product);
            return -1;
        }
        productData.add =  function(product)
        {
            this.indexProducts.push(product);
            if (product.isDeleted)
            {
                var index = this.deletedProducts.indexOf(product)
                if (index==-1)
                    this.deletedProducts.push(product);
            }
            return this.indexProducts.length-1;
        }
        productData.remove =  function(product) //Soft Remove
        {
            var index =  this.deletedProducts.indexOf(product);
            if (index==-1)
            {
                this.deletedProducts.push(product)
                product.isDeleted=true;
            }

        }
        productData.restore =  function(product) //Soft Remove
        {
            var index =  this.deletedProducts.indexOf(product);
            if (index!=-1)
            {
                this.deletedProducts.splice(index,1)
                product.isDeleted=false;
            }

        }
        productData.clear =  function()
        {
            productData.indexProducts = [];
            productData.deletedProducts = [];
        }
        productData.getDeletedList =  function()
        {
            return productData.deletedProducts;
        }

        productData.getActiveList =  function()
        {
            return this.indexProducts;
        }

        return productData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/Product.js